import { useTranslation } from 'react-i18next';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IOfferRowProps {}

export function OfferRow(props: IOfferRowProps) {
  const { t } = useTranslation();

  return (
    <div className="w-full text-center border-b p-2 mb-4 bg-brand-pink">
      <span className="text-white text-sm font-light">
        {t('offer-row.title')}
      </span>
    </div>
  );
}
